// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index__1BSGBES8{overflow:hidden;width:100%}.index_fetching_first_frame__1BSGBES8 [class^=vjs-big-play-button]{display:block!important}", ""]);
// Exports
exports.locals = {
	"root": "index__1BSGBES8",
	"fetching_first_frame": "index_fetching_first_frame__1BSGBES8"
};
module.exports = exports;
